import React, { useState, useRef, useEffect } from "react";
import { Icon, Dropdown } from "semantic-ui-react";
import html2canvas from "html2canvas";
import moment from "moment";
import { kFormatter } from "../../../../../Dashboard/Charts/utils";
import NoData from "../../../../../Dashboard/Charts/NoData/NoData";
import DimmerComponent from "../../../../../Dashboard/DimmerComponent";
import { downloadCSVData, downloadCanvasWithTitle } from "../../../../../Dashboard/Charts/utils";
import { ReactComponent as MoreOptions } from "../../../../../../../assets/svg/menu.svg";
import ChartOptionsSidebar from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/ChartOptionsSidebar";
import CustomCheckBox from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/CustomCheckBox";
import ChartName from "../../../../../Dashboard/Charts/ChartName";
import FBPageSelector from "../../../../../FbInsights/FBPageSelector";
import DeleteWidget from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as CloneIcon } from "../../../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../../../../assets/svg/settings.svg";
import { ReactComponent as DownloadIcon } from "../../../../../../../assets/svg/downloads.svg";
import { ReactComponent as ArrowIcon } from "../../../../../../../assets/svg/chevron.svg";
import { ChartFilterIcon } from "../../../../../Dashboard/Charts/ChartFilterOptions";
import TwitterPageSelector from "../TwitterPageSelector";
import "./RecentPosts.scss";
import TwitterPost from "./TwitterPost";
import { ReactComponent as MiniMize } from "../../../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import CustomDropdown from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/CustomDropdown";

function RecentPosts(props) {
    const [downloading, setDownloading] = useState(false);
    const [postOrderBy, setPostOrderBy] = useState("date_desc");
    const carouselRef = useRef(null);
    const chartEl = useRef();
    const [currentScroll, setCurrentScroll] = useState(0);
    let nodata = props.pageStatus || props.data === undefined || props.data?.data?.length === 0;
    // let scrollAllowed = Math.floor(carouselRef?.current?.scrollWidth / carouselRef?.current?.clientWidth);

    const totalData = props.data?.data;

    // useEffect(() => {
    //     setPostOrderBy("date_desc");
    // }, [props.data]);

    const nextPage = () => {
        carouselRef.current.scrollBy({
            left: carouselRef.current.clientWidth,
            behavior: "smooth",
        });
        setCurrentScroll(currentScroll + 1);
    };

    const previousPage = () => {
        carouselRef.current.scrollBy({
            left: -carouselRef.current.clientWidth,
            behavior: "smooth",
        });
        setCurrentScroll(currentScroll - 1);
    };

    const postOrderByList = [
        { label: "Most Recent", value: "date_desc", param: "date" },
        // { label: "Least Recent", value: "date_asc", param: "date" },
        { label: "Most Liked", value: "like_desc", param: "likes" },
        { label: "Least Liked", value: "like_asc", param: "likes" },
        { label: "Most Quotes", value: "quotes_desc", param: "quotes" },
        { label: "Least Quotes", value: "quotes_asc", param: "quotes" },
        { label: "Most Retweets", value: "retweets_desc", param: "retweets" },
        { label: "Least Retweets", value: "retweets_asc", param: "retweets" },
        { label: "Most Replies", value: "replies_desc", param: "replies" },
        { label: "Least Replies", value: "replies_asc", param: "replies" },
        { label: "Most Engagement", value: "engagements_desc", param: "engagements" },
        { label: "Least Engagement", value: "engagements_asc", param: "engagements" },
        { label: "Most Impressions", value: "impressions_desc", param: "impressions" },
        { label: "Least Impressions", value: "impressions_asc", param: "impressions" },
    ];

    const increment = () => {
        if (props.twitterPageList.length === 1) return;
        let index;
        props.twitterPageList.map((value, ind) => {
            if (value.value === props.selectedTwitterPage.value) index = ind;
        });
        if (index === props.twitterPageList.length - 1) props.setSelectedTwitterPage(props.twitterPageList[0]);
        else props.setSelectedTwitterPage(props.twitterPageList[index + 1]);
    };

    const decrement = () => {
        if (props.twitterPageList.length === 1) return;
        let index;
        props.twitterPageList.map((value, ind) => {
            if (value.value === props.selectedTwitterPage.value) index = ind;
        });
        if (index === 0) props.setSelectedTwitterPage(props.twitterPageList[props.twitterPageList.length - 1]);
        else props.setSelectedTwitterPage(props.twitterPageList[index - 1]);
    };

    const changePostOrderBy = (val) => {
        setPostOrderBy(val);

        carouselRef.current.scrollTo({
            left: 0,
            behavior: "smooth",
        });

        setCurrentScroll(0);
    };

    const getPosts = () => {
        if (!totalData) return;
        let posts = [...totalData];

        if (postOrderBy !== "date_desc") {
            let order = postOrderBy.indexOf("desc") > -1 ? -1 : 1;
            let orderBy = postOrderByList.find((p) => p.value === postOrderBy).param;

            posts.sort((a, b) => order * (a[orderBy] - b[orderBy]));
        } else {
            posts.sort((a, b) => -1 * moment(a["publishedDate"]).isAfter(moment(b["publishedDate"])));
        }

        posts = posts.slice(0, 10);

        return posts?.map((post) => <TwitterPost key={post.post_id} data={post} profilePic={props.selectedTwitterPage.profile_pic} />);
    };

    const elements = (
        <>
            <div className="dashboard-widget-container-header skiptranslate">
                <ChartName
                    isTwitter
                    isTWPage={props.isTWPage}
                    name={props.widget?.name || "Recent Posts"}
                    info="This section show tweets based on the sorting options selected in the widget."
                />
                <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                    {!props.isTWPage &&
                        !props.isPublic &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && (
                            <ChartFilterIcon
                                chartFilterApplied={props.chartFilterApplied}
                                changeShowChartFilterOptions={props.changeChartFilter}
                                widgetListDashboardCurrent={props.widgetListDashboardCurrent}
                                name={props.widget.name}
                            />
                        )}
                    {/* {!props.isPublic && !props.isResearchDashboard && <>{renderDownloadButton(nodata)}</>} */}
                    {
                        <>
                            {(props.isPublic && nodata) || props.isTWPage ? null : (
                                <Popup
                                    className="skiptranslate"
                                    trigger={
                                        props.expand ? (
                                            <MiniMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                        ) : (
                                            <MaxiMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                        )
                                    }
                                    inverted
                                    content={props.expand ? "Minimize Widget" : "Maximize Widget"}
                                    size="mini"
                                    position="bottom center"
                                    style={{ zIndex: "99999" }}
                                />
                            )}
                        </>
                    }

                    {!props.isPublic && <MoreOptions className="more-options" onClick={(e) => props.changeShowMoreOptions(e)} />}
                </div>
            </div>
            {props.showMoreOptions && (
                <ChartOptionsSidebar
                    data-html2canvas-ignore="true"
                    showMoreOptionsLoc={props.showMoreOptionsLoc}
                    changeShowMoreOptions={props.changeShowMoreOptions}>
                    {/* {!props.isTWPage &&
                        !props.isStandardDashboard &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && (
                        )} */}
                    <>
                        <CustomDropdown className="sort-by" name="Sort By" options={postOrderByList} value={postOrderBy} onChange={changePostOrderBy} />
                    </>
                    {!props.isTWPage &&
                        !props.isStandardDashboard &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && (
                            <>
                                <div className="chart-settings menu-option" onClick={props.chartSettings}>
                                    <span>Chart Configuration</span>
                                    <Settings />
                                </div>
                                <div className="clone-chart menu-option" onClick={props.cloneWidget}>
                                    <span>Clone Chart</span>
                                    <CloneIcon />
                                </div>
                                <DeleteWidget onClick={props.deleteWidget} />
                            </>
                        )}
                </ChartOptionsSidebar>
            )}

            <div className="dashboard-chart dashboard-chart-slider skiptranslate" ref={chartEl}>
                {!props.isTWPage && (
                    <div
                        data-html2canvas-ignore="true"
                        className={`chart-slider chart-slider-left ${props.twitterPageList?.length === 1 ? "disabled" : ""}`}
                        onClick={decrement}>
                        <ArrowIcon />
                    </div>
                )}
                <div className="chart-area">
                    {!props.isTWPage && props.selectedTwitterPage && (
                        <TwitterPageSelector
                            selectedTwitterPage={props.selectedTwitterPage}
                            setSelectedTwitterPage={props.setSelectedTwitterPage}
                            twitterPageList={props.twitterPageList}
                            widgetContainerRef={props.widgetContainerRef}
                        />
                    )}
                    {!nodata ? (
                        <div className="twRecentPosts">
                            {props.isTWPage && totalData?.length > 3 && (
                                <div className="leftArrow" onClick={previousPage}>
                                    <Icon name="arrow left" size="large" />
                                </div>
                            )}
                            {!props.isTWPage && (
                                <div className="leftArrow" onClick={previousPage}>
                                    <Icon name="arrow left" size="large" />
                                </div>
                            )}

                            <div className="carousel" ref={carouselRef}>
                                {getPosts()}
                            </div>

                            {props.isTWPage && totalData?.length > 3 && (
                                <div className="rightArrow" onClick={nextPage}>
                                    <Icon name="arrow right" size="large" />
                                </div>
                            )}
                            {!props.isTWPage && (
                                <div className="rightArrow" onClick={nextPage}>
                                    <Icon name="arrow right" size="large" />
                                </div>
                            )}

                            {(downloading || !props.selectedTwitterPage || props.loading) && <DimmerComponent />}
                        </div>
                    ) : (
                        <NoData message={props.pageStatus ? "Page is Inactive. Please re-authenticate" : ""} />
                    )}
                </div>
                {!props.isTWPage && (
                    <div
                        data-html2canvas-ignore="true"
                        className={`chart-slider chart-slider-right ${props.twitterPageList?.length === 1 ? "disabled" : ""}`}
                        onClick={increment}>
                        <ArrowIcon />
                    </div>
                )}
            </div>
        </>
    );

    return props.isTWPage ? <div className="dashboard-widget-container">{elements}</div> : <>{elements}</>;
}

export default RecentPosts;
